import useCampaignNavigate from 'hooks/useCampaignNavigate';
import { Button } from 'nhsuk-react-components';

function SummaryReportRequestedPage() {
  const { navigateToCampaign } = useCampaignNavigate();

  const handleReturnToSummary = () => {
    navigateToCampaign('summary');
  };

  return (
    <>
      <div className="nhsuk-grid-row">
        <div className="nhsuk-grid-column-two-thirds">
          <div className="nhsuk-panel">
            <h1 className="nhsuk-panel__title">
              Your report has been requested
            </h1>
            <div className="nhsuk-panel__body">
              When the report is ready, we&apos;ll email the reviewer(s).
            </div>
          </div>
        </div>
      </div>

      <Button className="nhsuk-button--secondary-solid" onClick={handleReturnToSummary}>Continue to campaign summary</Button>
    </>
  );
}

export default SummaryReportRequestedPage;
